import api from './api';

export const auditService = {
  /**
   * Get all unsubmitted benefits for the audit report.
   */
  getAuditReport: async () => {
    const response = await api.get('/reports/audit');
    return response.data;
  },

  /**
   * Update a benefit's status and details.
   */
  updateBenefit: async (id, updateData) => {
    const response = await api.put(`/reports/audit/${id}`, updateData);
    return response.data;
  },

  /**
   * Submit all approved and rejected benefits to CCB.
   */
  submitAudit: async () => {
    const response = await api.post('/reports/audit/submit', {});
    return response.data;
  }
};